import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';

export function competitionDisplay(component: any) {
    if (!component) return;

    const {title = '', description = '', entries = []} = component.fields ?? {};
    const logos = entries?.map((entry: any) => {
        return {
            title: entry?.fields?.title,
            logo: entry?.fields?.logo?.fields?.file?.url
        };
    });
    return {
        title,
        description,
        componentType: ComponentTypes.COMPETITION_DISPLAY,
        logos: logos ?? []
    };
}
